import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
export class EventNavbarService {
    constructor() {
        this.invokeFirstComponentFunction = new EventEmitter();
    }
    openNavbar() {
        this.invokeFirstComponentFunction.emit();
    }
}
EventNavbarService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EventNavbarService_Factory() { return new EventNavbarService(); }, token: EventNavbarService, providedIn: "root" });
